module.exports = __webpack_public_path__ + "static/Especialistas_PreventFormationOfLiquid_BabakShobeir-691c3f7c9878300715e56ecc0cda1bbf.png";